var app = angular.module("nms.dwdmMuxDemux", []);

app.config(["$translatePartialLoaderProvider", function($translatePartialLoader) {
    $translatePartialLoader.addPart("features/topology/dwdm-mux-demux");
}]);

app.run(["$translate", function($translate) {
        $translate.refresh();
    }
]);
